var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTips = function SvgIconTips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3m0 28a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0-20c-.796 0-1.558.307-2.121.852A2.87 2.87 0 0 0 21 13.91v10.182c0 .771.316 1.51.879 2.057A3.05 3.05 0 0 0 24 27c.796 0 1.558-.307 2.121-.852A2.87 2.87 0 0 0 27 24.09V13.909c0-.771-.316-1.51-.879-2.057A3.05 3.05 0 0 0 24 11",
    clipRule: "evenodd"
  })));
};
export default SvgIconTips;